import React, { useState, useEffect, useContext } from "react";
import { Button, Card } from "react-bootstrap";
import { BsGear } from "react-icons/bs";
import MaterialTable, { MTableToolbar } from 'material-table';
import icons from 'MaterialTableIcons';
import { Link } from 'react-router-dom';
import { contrastColor } from 'contrast-color';
import Gradient from 'javascript-color-gradient';
import { useHistory } from 'react-router-dom';
import AppContext from 'Utils/AppContext';
import DiscoveryTooltip from "DiscoveryTooltip";

const colorGradient = new Gradient();
colorGradient.setGradient('#ffffff', '#7360F6');
colorGradient.setMidpoint(100);
const colorGradientArray = colorGradient.getArray();

const IdColumn = (props) => {
  return (
    <div 
      className="truncate-ellipsis pl-3 pt-3 pb-3"
    >
      <DiscoveryTooltip text='View sampling rules details' placement='top'>
        <Link to={`/rules/rules-editor/${encodeURIComponent(props.id)}`}>
          {props.id}
        </Link>
      </DiscoveryTooltip>
    </div>
  );
}

const getHeatmapColor = (count, maxCount) => {
  let index = (Math.floor(count / maxCount * 100)) - 1;

  if (index <= 0) {
    index = 0;
  } else if (index >= 99) {
    index = 99;
  }
  return colorGradientArray[index];
}

const HeatmapCell = (props) => {
  return (
    <div
      style={{ 
        color: contrastColor({ bgColor: props.color }),
        backgroundColor: props.color
      }}
      className="pl-4 pr-4 pt-3 pb-3 discovery-badge-db-tables heatmap-cell-text"
    >
    {props.percent}%
    </div>
  )
}


const RulesTable = (props) => {
  const [data, setData] = useState([]);
  const tableRef = React.createRef();
  const history = useHistory();
  // Sampling rule sets are one global admin-managed list; only admins can add.
  const { isAdmin } = useContext(AppContext);

  useEffect(() => {
    const rulesList = props.rulesList;
    const dataValue = [];

    if (rulesList) {
      try {
        for (let i = 0; i < rulesList.length; i++) {
          const rules = rulesList[i];

          if (rules && rules.sample && rules.sample.row) {
            let every = rules.sample.row.every;
            let size = rules.sample.row.size;
            let percent = (100 * size) / every;
            let item = rules;
            item.percent = percent;
            dataValue.push(item);
          }
        }
      } catch(e) {
        console.log(e);
      }
    }
    setData(dataValue);
  }, [props.rulesList]);

  const COLUMNS = [
    {
      title: 'NAME',
      field: 'name',
      headerStyle: {
        fontFamily: 'Rubik'
      },
      cellStyle: {
        fontFamily: 'Rubik',
      },
      render: (rowData) => (
        <IdColumn
          id={rowData.name}
          index={rowData.index}
        />
      )
    },
    {
      title: 'SAMPLING %',
      field: 'searchQty',
      width: '50%',
      headerStyle: {
        fontFamily: 'Rubik',
        textTransform: 'uppercase',
        textAlign: 'center'
      },
      cellStyle: { 
        padding: 0, 
        fontFamily: 'Rubik' 
      },
      render: (rowData) => {
        const color = getHeatmapColor(rowData.percent, 100);
        return (
          <HeatmapCell 
            color={color}
            percent={rowData.percent}
          />
        );
      }
    },
  ];

  return (
    <Card className="entity-panel-table">
      <MaterialTable
        components={{
          Toolbar: props => (
            <div className="entity-panel-table-header d-flex">
              <div className="text-left w-50 widget-header p-3">
                <BsGear className="mr-2 widget-header-icon" /> 
                <span>Create / Manage Sampling Rules</span>
              </div>
              <div className='d-flex justify-content-end w-75'>
                <MTableToolbar { ...props } />
                { isAdmin &&
                  <Button
                    onClick={() => history.push('/rules/rules-editor')}
                    variant='primary'
                    className='add-data-source-btn m-1 pl-5 pr-5'
                    style={{ height: '42px' }}
                  >
                    + ADD
                  </Button>
                }
              </div>
            </div>
          )
        }}
        tableRef={tableRef}
        icons={icons}
        columns={COLUMNS}
        data={data}
        options={{
          // fixedColumns: props.entity === 'ALL' ?  { left: 2 } : null,
          showTitle: false,
          pageSize: props.pageSize,
          tableLayout: 'fixed'
        }}
      />
    </Card>
  );
}

export default RulesTable;